import React from "react";
import Weather from "./Weather";
import Profile from "./Profile";
import Rightlist from "./Rightlist";

function Rightmenu() {
    return(
      <div style={{backgroundColor:'',
      height:'1200px'
      }}>
          <div style={{textAlign:'center'}}></div>
          <Profile></Profile>
          <br></br>
          <Rightlist></Rightlist>
          <br></br>
          <Weather></Weather>
          
      
      </div>
      

    )
}

export default Rightmenu